import styles from "./styles.scss";
import ChatListEmpty from "../chat-list-empty";
import ContactList from "../contact-list";
import Chat from "../chat";
import { useContext } from "preact/hooks";
import {CurrentUserContext, MessagesContext, RoomsContext} from "../../contexts";
import ChatList from "../chat-list";
import ChatDetailsPage from "../../containers/ChatDetailsPage/ChatDetailsPage";
import ChatSearchResultsPage from "../../containers/ChatSearchResultsPage/ChatSearchResultsPage";
import VideoCallLobby from "../../containers/VideoCallLobby/VideoCallLobby";
import {GlobalContext} from "../../contexts/GlobalContext";
import {NavigationContext} from "../../contexts/NavigationContext";

const AppContent = ({ showAlert, onRequestMoreMessages, updateOrganization }) => {
  const { options } = useContext(GlobalContext);
  const messages = useContext(MessagesContext);
  const currentUser = useContext(CurrentUserContext);
  const rooms = useContext(RoomsContext);
  const { route } = useContext(NavigationContext);

  let contentClasses = [
    styles.content,
    options.displayMode === 'expand-in-container' && styles.contentExpandInPlace,
    options.hideAppBar && styles.contentHideAppBar
  ];

  return (
    <div className={contentClasses.join(" ")}>
      {route.path === "/" &&
        (messages.length === 0 ? (
          <ChatListEmpty />
        ) : (
          <ChatList />
        ))}
      {route.path === "/contacts" && <ContactList />}
      {route.path === "/chat" && (
        <Chat
          showAlert={showAlert}
          contactInternalId={route.params.contactInternalId}
          roomId={route.params.roomId}
          broadcastList={route.params.broadcastList}
          onRequestMoreMessages={onRequestMoreMessages}
        />
      )}
      {route.path === "/chat-search" && (
        <ChatSearchResultsPage query={route.params.query} roomId={route.params.roomId} />
      )}
      {route.path === "/chat-details" && (
        <ChatDetailsPage roomId={route.params.roomId} />
      )}
      {route.path === "/video-call-lobby" && <VideoCallLobby
        currentUser={currentUser}
        roomId={route.params.roomId}
        contactInternalId={route.params.contactInternalId}
        partnerStreamingSince={route.params.partnerStreamingSince}
        messages={messages}
        rooms={rooms}
        updateOrganization={updateOrganization}
      />}
    </div>
  );
};

export default AppContent;



// WEBPACK FOOTER //
// ./components/app-content/index.js